export default __webpack_public_path__ + "static/media/checked.531db61d.svg";